import { render, staticRenderFns } from "./LP.vue?vue&type=template&id=b71ddb02&"
import script from "./LP.vue?vue&type=script&lang=js&"
export * from "./LP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Footer: require('/app/components/admin/Footer.vue').default})
